export default "__VITE_ASSET__VwyTU4Wm__"